var map = {
	"./year_2012.svg": [
		"UMsJ",
		9
	],
	"./year_2013.svg": [
		"cxuM",
		10
	],
	"./year_2014.svg": [
		"FQ5d",
		11
	],
	"./year_2015.svg": [
		"9PKv",
		12
	],
	"./year_2016.svg": [
		"3IYa",
		13
	],
	"./year_2017.svg": [
		"Dd16",
		14
	],
	"./year_2018.svg": [
		"ddfy",
		15
	],
	"./year_2019.svg": [
		"UAfn",
		16
	],
	"./year_2020.svg": [
		"kWuB",
		17
	],
	"./year_2021.svg": [
		"sY2d",
		18
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1Kl9";
module.exports = webpackAsyncContext;